<template>
  <div class="">
      <v-row>
        <v-col cols="12" sm="6">
          <v-card>
            <v-card-title class="subtitle-2">
              <v-icon></v-icon> {{ $t("activeAgents") }}
            </v-card-title>
            <v-card-text> {{ data.agents.count_agents }}</v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card>
            <v-card-title class="subtitle-2">
              <v-icon></v-icon> {{ $t("areas") }}
            </v-card-title>
            <v-card-text>{{ data.areas.count_area }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title class="subtitle-2 pb-0"
              >{{ $t("weeklyChart") }} | {{ $t("grossAndPremium") }}
            </v-card-title>
            <v-card-text class="pb-0">
              {{ $t("from") }}
              {{ new Date(start_date.replace(" ", "T")).toLocaleDateString() }}
              {{ $t("until") }}
              {{ new Date(final_date.replace(" ", "T")).toLocaleDateString() }}
            </v-card-text>
            <div class="pa-6">
              <HorizontalBarChart :data="data" />
            </div>
          </v-card>
        </v-col>
      </v-row>
  </div>
</template>
<script>
import HorizontalBarChart from "@/components/Charts/HorizontalBarChart";

export default {
  name: "administrator-dashboard-home",
  components: {
    HorizontalBarChart,
  },
  data: () => ({
    data: {
      agents: { count_agents: 0 },
      areas: { count_area: 0 },
    },
    start_date: "",
    final_date: "",
  }),
  async created() {
    const response = await this.$request.get("administrator/dashboard/home");
    this.data = response;
    this.start_date = this.data.start_date;
    this.final_date = this.data.final_date;
  },
};
</script>